import { Alert, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { TOUCH_TARGET_PX } from '../../config/touch-target';
import { stackAlertActionBelowOnMobile } from '../alert-stacked-action-sx';
import type { ConsultantAssistantBlock } from './consultant-assistant-block';

/** A 403 of the consultant AI assistant: no retry can succeed, the way out is the consultant area. */
export function ConsultantAssistantBlockedAlert({ reason }: { reason: ConsultantAssistantBlock }) {
  const { t } = useTranslation();
  return (
    <Alert
      sx={(theme) => stackAlertActionBelowOnMobile(theme, 'md')}
      action={
        <Button
          color="inherit"
          component={Link}
          size="small"
          sx={{ minHeight: TOUCH_TARGET_PX }}
          to="/consultant"
        >
          {t('guida.assistant.noConsultantWorkspaceCta', {
            defaultValue: 'Apri area consulente',
          })}
        </Button>
      }
      severity="warning"
    >
      {reason === 'aiDisabled'
        ? t('guida.assistant.consultantAiDisabled', {
            defaultValue:
              'L’assistente IA non è attivo per i consulenti del tuo studio: chiedi a Prospero di attivarlo. Le richieste ai clienti restano disponibili.',
          })
        : t('guida.assistant.noConsultantWorkspace', {
            defaultValue:
              'L’assistente dello scadenzario è disponibile solo per i consulenti partner con uno studio attivo.',
          })}
    </Alert>
  );
}
